<script>
  import {Doughnut, mixins} from 'vue-chartjs'
  import ChartDataLabels from 'chartjs-plugin-datalabels';
  export default {
    extends: Doughnut,
    components: {
      ChartDataLabels,
    },
    mixins: [mixins.reactiveProp],
    props: ['options'], // chartData added by the reactiveProp
    name: "gaugeChart",
    mounted() {
      this.renderChart(this.chartData, this.options)
    },
  }
</script>

<style scoped>
</style>
